import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import {
  Identifiable,
  Planzone,
  PlanzoneSettings,
  ProjectListingConfiguration,
} from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  configuration: ProjectListingConfiguration;
  retrieveProjectListingConfiguration(
    req: Boundaries["retrieveProjectListingConfiguration"]["request"],
  ): void;
}

function useRetrieveProjectListingConfiguration(
  planzone: Identifiable<Planzone>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveProjectListingConfigurationRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveProjectListingConfigurationRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveProjectListingConfigurationRequestFailure(planzone),
    ),
    configuration: useSelector(() =>
      selector.getProjectListingConfiguration(planzone),
    ),
    retrieveProjectListingConfiguration:
      core.retrieveProjectListingConfiguration,
  };
}

export { useRetrieveProjectListingConfiguration };
